import React, { useContext } from 'react';
import { loginAsUserGet, userGet } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import { userIsDisabled, somethingWentWrongNotice } from '../UI/Notifications';
import { SearchContext } from '../../context/Search';

const LoginAsUser = ({ id, status }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const history = useHistory();
  const { setLoading } = useContext(SearchContext);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Login As User");
    }

    setLoading(false);
  }

  const loginAsUserHandler = () => {
    if (status) {
      setLoading(true);
      loginAsUserGet({login: id})
      .then(() => {
        userGet()
          .then(response => {
            setIsLoggedIn(true);
            setUser(response.data);
            history.push('/dashboard');
          })
          .catch(error => handleDefaultStatusCodes(error.response.status));
      })
      .catch(error => handleDefaultStatusCodes(error.response.status));
    } else {
      userIsDisabled("You can't login as user when user is disabled.");
    }
  }

  return (
    <>
      <div
        onClick={() => loginAsUserHandler()}
        className="Dropdown_Item"
      >
        <span className="ml-2">Login as User</span>
      </div>
    </>
  )
}

export default LoginAsUser;
